<script>
import { mapState, mapMutations } from 'vuex';
import { get } from 'lodash';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faFirstAid } from '@fortawesome/free-solid-svg-icons';

import config from '@/config/config';

library.add( faFirstAid );

export default {
  name: 'ComponentsCourseInfo',
  computed: {
    ...mapState(config.app, [
      'course',
    ]),
    title() {
      return get(this, 'course.title', '');
    },
    content() {
      return get(this, 'course.content', '');
    },
    flow() {
      return config.initial.course;
    },
  },
  methods: {
    ...mapMutations(config.app, [
      'setCurrentCourse',
    ]),
  },
};
</script>
<template>
    <div id="course-info">
        <div class="d-flex title">
            <font-awesome-icon icon="first-aid" class="mr-2" />
            <h1>{{ title }}</h1>
        </div>
        <div v-html="content" class="mt-5" />
        <button class="btn" @click="setCurrentCourse(flow.video)">
            Przejdź do kursu
        </button>
        <!-- <button class="btn" @click="setCurrentCourse(flow.lecture)">
            Przejdź do kursu
        </button> -->
    </div>
</template>
